<template>
	<AppButton
		startIcon="assets/v2/image/icons/plus.svg"
		:label="$t('campaigns.other.newCampaign')"
		variant="brand"
		size="md"
		@click="redirectToCreate()"
		:disabled="authStore.isAgentSubscriptionExpired"
	/>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/v2/store/shared/auth-store';

const router = useRouter();
const authStore = useAuthStore();

const redirectToCreate = () => {
	router.push({ name: 'whatsapp-create-campaign' });
};
</script>

<style lang="scss" scoped></style>
